import React from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import logo from "../../assets/images/logo.png";
import { IoArrowForwardOutline } from "react-icons/io5";
import Button from "../../components/Button";

const SetPassword = () => {
  return (
    <section>
      <Container maxWidth={"max-w-3xl"}>
        <div className="header my-6">
          <div className="flex justify-between items-center">
            <div className="logo w-28">
              <Link to={"/everyone"}>
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="sign-in">
              <Link to={"/everyone"} className="flex items-center gap-3 p-3">
                <span>Sign In</span>
                <span>
                  <IoArrowForwardOutline />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white xs:p-4 md:p-10 border rounded-lg">
          <div className="text-lg font-semibold mb-6">
            <p className="">Set your password!</p>
          </div>
          <div className="form my-3">
            <form action="">
              <div className="email mb-4">
                <div className="confirmed-email py-2 px-4 border rounded-full text-gray-500">
                  <span>example@example.com</span>
                </div>
              </div>
              <div className="new-password mb-4">
                <CustomInput
                  label={"New Password"}
                  placeholder="Type new password"
                  name="password"
                  type="password"
                  className="w-full mb-4"
                />
              </div>
              <div className="new-password mb-4">
                <CustomInput
                  label={"Retype Password"}
                  placeholder="Retype new password"
                  name="password"
                  type="password"
                  className="w-full mb-4"
                />
              </div>
              <div className="continue mb-4">
                <Link to="/everyone">
                  <Button width={"w-full"}>Save</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SetPassword;
